const angular = require('angular');
const app = angular.module('learn-services');

/**
 * Service for adding and updating multiple users at a time
 * @argument {Application} Application defines the Application service
 * @argument {$q} $q defines the $q service
 * @argument {Users} Users defines the Users resource
 */
app.factory('AccessHelper', ['Access', 'Authorization', 'Navigation', 'AuthorizationResource', 'Assessments', 'Users', '$q', function (Access, Authorization, Navigation, AuthorizationResource, Assessments, Users, $q) {

  var inRecheck = false;

  var roleCheck = function(roles) {
    if (!roles || !roles.length) {
      return true;
    }
    var role = Access.role;

    for (var i = 0; i < roles.length; i++) {
      if (roles[i] === 'collaborator' && Authorization.isCollaborator()) {
        return true;
      }
      if (roles[i] === 'manager' && Authorization.isManager()) {
        return true;
      }
      if (roles[i] === role) {
        return true;
      }
    }

    return false;
  };

  var pathCheck = function(accessPath) {
    if (!accessPath || !accessPath.length) {
      return true;
    }
    var profile = Access.profile && Access.profile.permissions || {};
    // console.log('accessPath: ', accessPath)
    var check = accessPath.reduce(function(acc, value) {
      if (!acc) {
        return acc;
      }

      if (acc && acc[value]) {
        return acc[value];
      }

      return false;
    }, profile);

    if (check === true) {
      return true;
    }

    return false;
  };

  var combinedCheck = function(accessPath, multiPath, roles) {
    // check role
    if (!roleCheck(roles)) {
      return false;
    }

    // if no profile allow based on role check
    if (!Access.profile) {
      return true;
    }

    // check initial path
    if (pathCheck(accessPath)) {
      // console.log('true')
      return true;
    }

    // check alternate path
    if (multiPath && multiPath.length) {
      for (var i = 0; i < multiPath.length; i++) {
        if (pathCheck(multiPath[i])) {
          // console.log('true')
          return true;
        }
      }
    }

    return false;
  };

  var isAllowed = function(accessPath, multiPath, roles) {
      // If profile hasn't been checked or no user - deny access and signout
    if (!Access.profileChecked || !Access.user || !Access.user._id) {
      console.log('no profile or user - signout');
      Authorization.signout();
      return false;
    }

    if (!inRecheck && Access.profileRecheck < new Date().valueOf()) {
      // Refresh profile to be used in all following checks
      inRecheck = true;
      Users.get({subresource: Access.user._id, fields: 'first_name,last_name,email,role,access_profile', 'access_profile-populate': 'permissions'}).$promise
      .then(function(user) {
        Access.setProfile(user.profile || null);
        Access.role = user.role;
        Access.user.role = user.role;
        inRecheck = false;
      }).catch(function(error) {
        // Error verifying user
        console.log('error getting user profile: ', error);
        Authorization.signout();
        inRecheck = false;
      });
    }

    if (combinedCheck(accessPath, multiPath, roles)) {
      return true;
    }

    return false;
  };

  var manualSessionData = function() {
    var deferred = $q.defer();

    AuthorizationResource.newToken().$promise.then(function(data) {
      if (data && data.company && data.company.suspended) {
        window.location.assign(window.location.origin + '/suspended');
        return;
      }
      Authorization.validateAndUseAuthToken(data);
      deferred.resolve(data);

    }).catch(function() {
      Authorization.clearAuthToken();
      Navigation.goTo('/signin');
      deferred.resolve(false);
    });


    return deferred.promise;
  };

  var allowGeneralActivity = function(type, roles) {
    

    roles = roles || ['admin'];
    var types = ['users', 'admin', 'content', 'createContent', 'workshops', 'assessments', 'assignments', 'journeys', 'third-party'];
    var checks = {
      users: [['admin', 'users', 'view'], ['admin', 'users', 'add']],
      connect: [['admin', 'connect', 'categories'],['admin', 'connect', 'locations'],['admin', 'connect', 'departments'],['admin', 'connect', 'teams'],['admin', 'connect', 'levels'],['admin', 'connect', 'grades'],['admin', 'connect', 'groups'],['admin', 'connect', 'skills']],
      content: [['admin', 'content', 'all_create'], ['admin', 'content', 'articles_create'], ['admin', 'content', 'files_create'], ['admin', 'content', 'videos_create'], ['admin', 'content', 'tracks_create'], ['admin', 'content', 'scorm_create'], ['admin', 'content', 'imported_content_create'], ['admin', 'content', 'all_edit'], ['admin', 'content', 'articles_edit'], ['admin', 'content', 'files_edit'], ['admin', 'content', 'videos_edit'], ['admin', 'content', 'tracks_edit'], ['admin', 'content', 'scorm_edit'], ['admin', 'content', 'imported_content_edit'], ['admin', 'content', 'all_analytics'], ['admin', 'content', 'articles_analytics'], ['admin', 'content', 'files_analytics'], ['admin', 'content', 'videos_analytics'], ['admin', 'content', 'tracks_analytics'], ['admin', 'content', 'scorm_analytics'], ['admin', 'content', 'imported_content_analytics']],
      createContent: [['admin', 'content', 'all_create'], ['admin', 'content', 'articles_create'], ['admin', 'content', 'files_create'], ['admin', 'content', 'videos_create'], ['admin', 'content', 'tracks_create'], ['admin', 'content', 'scorm_create'], ['admin', 'content', 'imported_content_create']],
      workshops: [['admin', 'content', 'all_create'], ['admin', 'content', 'workshops_create'], ['admin', 'content', 'all_edit'], ['admin', 'content', 'workshops_edit'], ['admin', 'content', 'workshops_analytics']],
      assessments: [['admin', 'content', 'all_create'], ['admin', 'content', 'assessments_create'], ['admin', 'content', 'all_edit'], ['admin', 'content', 'assessments_edit'], ['admin', 'content', 'all_analytics'], ['admin', 'content', 'assessments_analytics']],
      assignments: [['admin', 'assignments', 'view'], ['admin', 'assignments', 'edit'], ['admin', 'assignments', 'complete'], ['admin', 'assignments', 'create'], ['admin', 'assignments', 'archive']],
      journeys: [['admin', 'journeys', 'view'], ['admin', 'journeys', 'edit'], ['admin', 'journeys', 'create'], ['admin', 'journeys', 'archive']],
      theme: Access?.profile?.permissions?.explore?.update_theme,
    };

    if (types.indexOf(type) === -1) {
      return false;
    }

    for (var i = 0; i < checks[type].length; i++) {
      if (combinedCheck(checks[type][i], null, roles)) {
        return true;
      }
    }

    return false;
  };

  return {
    isAllowed: isAllowed,
    manualSessionData: manualSessionData,
    allowGeneralActivity: allowGeneralActivity
  };
}]);
